import {inject, observer} from 'mobx-react';
import Head from 'components/Header';

@inject(({store}) => ({
    dep: store.dep,
    deps: store.deps,
    setDep: store.setDep,
    jump: store.jump
}))
@observer
class Header extends React.Component {
    render() {
        const {dep, deps, jump, setDep} = this.props;
        return (
            <Head
                searchClick={() => {
                    jump({
                        appUrl: `://react/open?hybridId=vs_list_rn&pageName=Destination&initProps=${encodeURIComponent(JSON.stringify({
                            param: {
                                dep,
                                et: 'act_ss_20519'
                            }
                        }))}`,
                        touchUrl: 'https://touch.dujia.qunar.com/destination.qunar'
                    }, 'shuqi_search');
                    sendSK('click_search', {it: 'shuqi_search'});
                }}
                dep={dep}
                deps={deps}
                setDep={setDep}
            />
        );
    }
}

export default Header;